<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-7 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('school.school')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ trans('school.school') }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-5 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right ml-1"  @click="$router.push('/schools/create')"><i class="feather icon-plus"></i> {{trans('school.create_school')}}</button>
                    
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="feather icon-filter"></i> {{trans('general.filter')}}</button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">

                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterSchoolForm.keyword">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <date-range-picker :start-date.sync="filterSchoolForm.start_date" :end-date.sync="filterSchoolForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="schools.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterSchoolForm.sort_by" :order="filterSchoolForm.order" @updateSortBy="value => {filterSchoolForm.sort_by = value}"  @updateOrder="value => {filterSchoolForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="schools.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{trans('general.serial_number')}}</th>
                                            <th>{{trans('school.code')}}</th>
                                            <th>{{trans('school.name')}}</th>
                                            <th>{{trans('school.longitude')}}</th>
                                            <th>{{trans('school.latitude')}}</th>
                                            <th>{{trans('school.lga')}}</th>
                                            <th>{{trans('school.status')}}</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(school, index) in schools.data">
                                            <td v-text="index+1"></td>
                                            <td v-text="school.code"></td>
                                            <td v-text="school.name"></td>
                                            <td v-text="school.longitude"></td>
                                            <td v-text="school.latitude"></td>
                                            <td v-text="school.lga.name"></td>
                                            <td v-html="getStatus(school)"></td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    
                                                    <router-link :to="`/schools/${school.id}`" class="btn btn-success btn-sm" v-tooltip="trans('school.view_school')"><i class="feather icon-eye"></i></router-link>
                                                    <button class="btn btn-info btn-sm" v-tooltip="trans('school.edit_school')" @click.prevent="editSchool(school)" v-if="hasPermission('edit-schools')"><i class="feather icon-edit"></i></button>
                                                    <button class="btn btn-danger btn-sm" :key="school.id" v-if="hasPermission('delete-schools')" v-confirm="{ok: confirmDelete(school)}" v-tooltip="trans('school.delete_school')"><i class="feather icon-trash-2"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!schools.total" module="school" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" @click="$router.push('/schools/create')"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterSchoolForm.page_length" :records="schools" @updateRecords="getSchools"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import sortBy from '../../components/sort-by'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components : { sortBy,dateRangePicker },
        data() {
            return {
                userRole: '',
                schools: {
                    total: 0,
                    data: []
                },
                filterSchoolForm: {
                    keyword: '',
                    start_date: '',
                    end_date: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'name',
                        translation: i18n.school.name
                    },
                    {
                        value: 'address',
                        translation: i18n.school.address
                    },
                    {
                        value: 'gps_location',
                        translation: i18n.school.gps_location
                    },
                    {
                        value: 'lga_id',
                        translation: i18n.school.lga
                    },
                    {
                        value: 'status',
                        translation: i18n.school.status
                    }
                ],
                showFilterPanel: false,
            };
        },
        mounted(){
            if(!helper.hasPermission('list-schools')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('school')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getSchools();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getSchools(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterSchoolForm);
                axios.get('/api/schools?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.schools = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editSchool(school){
                this.$router.push('/schools/'+school.id+'/edit');
            },
            confirmDelete(school){
                return dialog => this.deleteSchool(school);
            },
            deleteSchool(school){
                axios.delete('/api/schools/'+school.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getSchools();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getStatus(school){
                return school.status ? ('<span class="badge badge-success">'+i18n.general.active+'</span>') : ('<span class="badge badge-danger">'+i18n.general.inactive+'</span>') ;
            }
        },
        watch: {
            filterSchoolForm: {
                handler(val){
                    setTimeout(() => {
                        this.getSchools();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
